import { AmountText } from '@/components/AmountText';
import type { ScheduleCData } from '@/api/hooks/useScheduleC';

type Line = ScheduleCData['lines'][number];

export function ScheduleAmount({ value }: { value: string | null }) {
  return value === null ? <span aria-label="No amount reported">—</span> : <AmountText value={value} />;
}

export function ScheduleCLineRow({ line, expanded, onToggle }: { line: Line; expanded: boolean; onToggle: () => void }) {
  return (
    <>
      <div className="grid min-h-12 grid-cols-[42px_minmax(0,1fr)_64px_100px_100px] items-center gap-2 border-t border-border px-3 text-sm">
        <span className="font-mono text-muted-foreground">{line.tax_line}</span>
        <button type="button" aria-expanded={expanded} onClick={onToggle} className="min-h-11 text-left text-foreground">
          <span>{line.label}</span>
          {line.uncategorized_count > 0 && <span className="ml-1 text-xs text-money-negative">· {line.uncategorized_count} uncategorized</span>}
          {line.preparer_required && <span className="ml-1 text-xs font-semibold text-warning-foreground">· Preparer calculation required</span>}
        </button>
        <span className="text-right text-muted-foreground">{line.row_count || '—'}</span>
        <span className="text-right"><ScheduleAmount value={line.recorded} /></span>
        <span className="text-right"><ScheduleAmount value={line.deductible} /></span>
      </div>
      {expanded && (
        <div className="border-t border-border bg-muted/30 px-12 py-3 text-xs text-muted-foreground">
          {line.preparer_required ? <p>{line.preparer_reason ?? 'Preparer calculation required.'}</p> : null}
          {line.warning === 'uncategorized' && <p className="text-money-negative">Uncategorized remains inside this line total until answered.</p>}
          {line.subgroups.length > 0 && <ul className="mt-2 space-y-1">{line.subgroups.map((group) => <li key={group.label}>{group.label} · {group.rows} rows · <ScheduleAmount value={group.amount} /></li>)}</ul>}
        </div>
      )}
    </>
  );
}

export default ScheduleCLineRow;
